export const gwShadows = {
  alert: '1px 1px 10px rgba(214, 46, 79, 0.3)',
  focus: '1px 1px 20px rgba(153, 203, 234, 0.85)',
}
